var _path, _g, _use, _use2, _use3, _use4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgFlagCn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE1C25",
    d: "M0 0h900v600H0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150,150) scale(3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M0,-30 17.63355,24.27051 -28.53171,-9.27051H28.53171L-17.63355,24.27051",
    fill: "#FF0"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(300,60) rotate(23.036243)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(360,120) rotate(45.869898)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(360,210) rotate(69.945396)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(300,270) rotate(20.659808)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFlagCn);
export default __webpack_public_path__ + "static/media/img_flag_cn.45b22766aa096ac5e98dcbdcda75f9f9.svg";
export { ForwardRef as ReactComponent };